module.exports = __webpack_public_path__ + "img/conductor-banner.ecbd5583.png";